import { Component, Input, forwardRef, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { CuratedFiltersFieldModel } from '../../models/curated-filters.field.model';
import { MentionsNoFacetFilterService } from '../../../../Common/Mentions/services/mentions-no-facet-filter.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { MentionSearchModel } from '../../../Shared/models/mention-search.model';
import { Subscription } from 'rxjs';
import { SavedSearchType } from '../../../../Common/MonitorShared/enum/saved-search-type.enum';

@Component({
    selector: 'agpr-curated-filters-field',
    templateUrl: './curated-filters-field.component.html',
    styleUrls: ['./curated-filters-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => CuratedFiltersFieldComponent)
        },
        MentionsNoFacetFilterService,
        {
            provide: FilterService,
            useExisting: MentionsNoFacetFilterService
        }
    ],
    standalone: false
})
export class CuratedFiltersFieldComponent extends AbstractFormFieldComponent implements OnInit, OnDestroy, OnChanges {
    subscriptions: Subscription[] = [];
    @Input() declare field: CuratedFiltersFieldModel;
    @Input() declare value: MentionSearchModel;

    constructor(
        private filterService: MentionsNoFacetFilterService
    ) {
        super();
        this.filterService.setRestrictedFilters();
    }

    ngOnInit() {
        this.subscriptions.push(
            this.filterService.getSearchFilters().subscribe(
                (searchCriteria) => {
                    if (!searchCriteria) {
                        return;
                    }
                    if (!this.value) {
                        this.value = new MentionSearchModel();
                        this.value.type = SavedSearchType.BRIEFING;
                    }
                    this.value.searchCriteria = searchCriteria;
                    this.changes.emit(this.value);

                }
            )
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('value')) {
            if (this.value) {
                this.filterService.getFiltersFromSearch(this.value.searchCriteria);
            } else {
                this.filterService.clearFilters();
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach((value) => {
            value.unsubscribe();
        });
    }
}

